import React, { useEffect, useState } from "react";
import { Select, Input } from "antd";
import { getProductQuestionsFilterOptions } from "api/ProductQuestions";
import { FilterState } from "./useFilterState";
import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 240px;
`;

const Field = styled.div``;

const FieldLabel = styled.div`
  margin-bottom: 4px;
  font-weight: 600;
`;

export const Filters = (props: { filters: FilterState }) => {
  const [integrations, setIntegrations] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    getProductQuestionsFilterOptions().then((res) => {
      setIntegrations(
        res.integrations.map((i) => ({ value: i.id, label: i.label })),
      );
    });
  }, []);

  return (
    <Wrap>
      <Field>
        <FieldLabel>Интеграция</FieldLabel>
        <Select
          mode="multiple"
          allowClear
          style={{ width: "100%" }}
          placeholder="Все"
          options={integrations}
          value={props.filters.state.marketplace_auth_id}
          onChange={(v) => props.filters.update({ marketplace_auth_id: v })}
        />
      </Field>
      <Field>
        <FieldLabel>Поиск по артикулу</FieldLabel>
        <Input
          value={props.filters.state.article}
          onChange={(e) => props.filters.update({ article: e.target.value })}
          placeholder="Артикул товара"
          allowClear
        />
      </Field>
      <Field>
        <FieldLabel>Поиск по тексту</FieldLabel>
        <Input
          value={props.filters.state.search}
          onChange={(e) => props.filters.update({ search: e.target.value })}
          placeholder="Текст вопроса"
          allowClear
        />
      </Field>
    </Wrap>
  );
};
